
import SuperAdminRepo from "../components/superadmin/AdminReport";

export default function SuperReport() {
  return (
    <div>
      <SuperAdminRepo />
    </div>
  );
}
